var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.authenticated)?_c('md-button',{on:{"click":function($event){return _vm.signIn()}}},[_vm._v("Login")]):_vm._e(),(_vm.authenticated)?_c('md-button',{on:{"click":function($event){return _vm.signOut()}}},[_vm._v("Logout "+_vm._s(_vm.username)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }